import { useQuery } from '@tanstack/react-query';

import { Funnel } from '../types';

import { axios } from '@/libraries/axios';
import { ExtractFnReturnType, QueryConfig, queryClient } from '@/libraries/react-query';

type GetFunnelsResult = { funnels: Funnel[] };
type GetFunnels = (params: { pageId: string }) => Promise<GetFunnelsResult>;

export const getFunnels: GetFunnels = (params) => {
  return axios.get(`/funnels`, { params });
};

type QueryFnType = typeof getFunnels;

type UseGetFunnelsOptions = {
  pageId: string;
  config?: QueryConfig<QueryFnType>;
};

export const useGetFunnels = ({ pageId, config = {} }: UseGetFunnelsOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['funnels', pageId],
    enabled: !!pageId,
    queryFn: () => getFunnels({ pageId }),
  });
};

export const getFunnelsData = (pageId: string) => {
  return queryClient.getQueryData<GetFunnelsResult>(['funnels', pageId]);
};

export const setFunnelsData = (pageId: string, data: GetFunnelsResult) => {
  queryClient.setQueryData(['funnels', pageId], data);
};
